module.exports = __webpack_public_path__ + "img/purchase2.44a9dc4b.png";